import { Container, Row } from "reactstrap";
import { DatePickerTitle, FormWidgetsTitle } from "../../../../../constants";
import DatePicker from "./datePicker";
import DefaultCalendar from "./DefaultCalendar";
import ReactstrapCalendar from "./ReactstrapCalendar";
import TimePicker from "./timePicker";
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";

const DatePickerContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={DatePickerTitle} parent={FormWidgetsTitle} />
      <Container fluid>
        <Row>
          <DefaultCalendar />
          <ReactstrapCalendar />
          <DatePicker />
          <TimePicker />
        </Row>
      </Container>
    </>
  );
};

export default DatePickerContainer;
